// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v2/secret.proto (package infinigence.infini.agentplatform.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v2/secret.proto.
 */
export const file_agentplatform_v2_secret: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate]);

/**
 * GenericServiceSecretData 通用服务类密钥数据（对象存储等 endpoint + ak/sk 结构共用）。
 *
 * @generated from message infinigence.infini.agentplatform.v2.GenericServiceSecretData
 */
export type GenericServiceSecretData = Message<"infinigence.infini.agentplatform.v2.GenericServiceSecretData"> & {
  /**
   * 服务 endpoint（展示不脱敏）
   * @gotags: json:"endpoint"
   *
   * @generated from field: string endpoint = 1;
   */
  endpoint: string;

  /**
   * 访问密钥 ID（展示脱敏）
   * @gotags: json:"access_key"
   *
   * @generated from field: string access_key = 2 [json_name = "access_key"];
   */
  accessKey: string;

  /**
   * 访问密钥 Secret（展示脱敏）
   * @gotags: json:"secret_key"
   *
   * @generated from field: string secret_key = 3 [json_name = "secret_key"];
   */
  secretKey: string;

  /**
   * 区域（展示不脱敏）
   * @gotags: json:"region,omitempty"
   *
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * 扩展选项
   * @gotags: json:"options,omitempty"
   *
   * @generated from field: map<string, string> options = 5;
   */
  options: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.GenericServiceSecretData.
 * Use `create(GenericServiceSecretDataSchema)` to create a new message.
 */
export const GenericServiceSecretDataSchema: GenMessage<GenericServiceSecretData> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_secret, 0);

/**
 * Secret 对外数据对象。data 用 oneof 承载不同类型的具体结构，
 * “选了哪个分支”即密钥类型（无独立 type 字段）。
 *
 * @generated from message infinigence.infini.agentplatform.v2.Secret
 */
export type Secret = Message<"infinigence.infini.agentplatform.v2.Secret"> & {
  /**
   * 记录 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id"
   *
   * @generated from field: string tenant_id = 2 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 名称（同用户下唯一）
   * @gotags: json:"name"
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * 创建时间（unix nano）
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 5 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间（unix nano）
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 6 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 具体密钥数据，选中的分支即密钥类型。
   *
   * @generated from oneof infinigence.infini.agentplatform.v2.Secret.data
   */
  data: {
    /**
     * 通用对象存储
     * @gotags: json:"oss,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v2.GenericServiceSecretData oss = 10;
     */
    value: GenericServiceSecretData;
    case: "oss";
  } | {
    /**
     * 阿里云 OSS
     * @gotags: json:"aliyun_oss,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v2.GenericServiceSecretData aliyun_oss = 11 [json_name = "aliyun_oss"];
     */
    value: GenericServiceSecretData;
    case: "aliyunOss";
  } | {
    /**
     * 火山 TOS
     * @gotags: json:"volcengine_tos,omitempty"
     *
     * @generated from field: infinigence.infini.agentplatform.v2.GenericServiceSecretData volcengine_tos = 12 [json_name = "volcengine_tos"];
     */
    value: GenericServiceSecretData;
    case: "volcengineTos";
  } | { case: undefined; value?: undefined };

  /**
   * DEK 加密后的密文（整份 data 序列化后加密）
   * @gotags: json:"-"
   *
   * @generated from field: bytes data_ciphertext = 100 [json_name = "data_ciphertext"];
   */
  dataCiphertext: Uint8Array;

  /**
   * KEK 包装后的 DEK
   * @gotags: json:"-"
   *
   * @generated from field: bytes wrapped_dek = 101 [json_name = "wrapped_dek"];
   */
  wrappedDek: Uint8Array;

  /**
   * 包装 DEK 所用的 KEK 版本引用
   * @gotags: json:"-"
   *
   * @generated from field: string kek_ref = 102 [json_name = "kek_ref"];
   */
  kekRef: string;

  /**
   * 密钥类型（落 DB type 列，读回时定位 oneof 分支）
   * @gotags: json:"-"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.SecretType store_type = 103 [json_name = "store_type"];
   */
  storeType: SecretType;

  /**
   * 密钥分组（落 DB group 列）
   * @gotags: json:"-"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.SecretGroup store_group = 104 [json_name = "store_group"];
   */
  storeGroup: SecretGroup;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.Secret.
 * Use `create(SecretSchema)` to create a new message.
 */
export const SecretSchema: GenMessage<Secret> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_secret, 1);

/**
 * SecretInfo 是随沙箱参数下发给 sandbox-manager 的密钥引用载荷：只含密文 +
 * 解开 DEK 所需的元信息，明文永不离开 agent-platform。sandbox-manager 用
 * wrapped_dek 调 DecryptDEK 换回 DEK，再本地解密 secret_data。
 *
 * @generated from message infinigence.infini.agentplatform.v2.SecretInfo
 */
export type SecretInfo = Message<"infinigence.infini.agentplatform.v2.SecretInfo"> & {
  /**
   * 对应的 Secret.ID
   * @gotags: json:"secret_id"
   *
   * @generated from field: string secret_id = 1 [json_name = "secret_id"];
   */
  secretId: string;

  /**
   * agent-platform 暴露 DecryptDEK 的 base URL
   * @gotags: json:"address"
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * base64(DEK 加密后的 secret payload)
   * @gotags: json:"secret_data"
   *
   * @generated from field: string secret_data = 3 [json_name = "secret_data"];
   */
  secretData: string;

  /**
   * base64(KEK 包装后的 DEK)
   * @gotags: json:"wrapped_dek"
   *
   * @generated from field: string wrapped_dek = 4 [json_name = "wrapped_dek"];
   */
  wrappedDek: string;

  /**
   * 数据加密算法，AES-256-GCM
   * @gotags: json:"algo"
   *
   * @generated from field: string algo = 5;
   */
  algo: string;

  /**
   * 包装 DEK 所用的 KEK 版本引用（空则尝试所有版本）
   * @gotags: json:"key_version"
   *
   * @generated from field: string key_version = 6 [json_name = "key_version"];
   */
  keyVersion: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.SecretInfo.
 * Use `create(SecretInfoSchema)` to create a new message.
 */
export const SecretInfoSchema: GenMessage<SecretInfo> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_secret, 2);

/**
 * SecretGroup 密钥分组，用于分类与查询。
 *
 * @generated from enum infinigence.infini.agentplatform.v2.SecretGroup
 */
export enum SecretGroup {
  /**
   * 未指定
   *
   * @generated from enum value: SECRET_GROUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 对象存储
   *
   * @generated from enum value: SECRET_GROUP_OBJECT_STORAGE = 1;
   */
  OBJECT_STORAGE = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v2.SecretGroup.
 */
export const SecretGroupSchema: GenEnum<SecretGroup> = /*@__PURE__*/
  enumDesc(file_agentplatform_v2_secret, 0);

/**
 * SecretType 密钥类型。每个 type 属于一个 group，并对应 Secret.data 的一个 oneof 分支。
 * 分支与 type 的映射在 handler 层维护（见 handlers/v2/secret/mapping.go）。
 *
 * @generated from enum infinigence.infini.agentplatform.v2.SecretType
 */
export enum SecretType {
  /**
   * 未指定
   *
   * @generated from enum value: SECRET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 通用对象存储
   *
   * @generated from enum value: SECRET_TYPE_OSS = 1;
   */
  OSS = 1,

  /**
   * 阿里云 OSS
   *
   * @generated from enum value: SECRET_TYPE_ALIYUN_OSS = 2;
   */
  ALIYUN_OSS = 2,

  /**
   * 火山 TOS
   *
   * @generated from enum value: SECRET_TYPE_VOLCENGINE_TOS = 3;
   */
  VOLCENGINE_TOS = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v2.SecretType.
 */
export const SecretTypeSchema: GenEnum<SecretType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v2_secret, 1);

